export const FETCH_LOGS_REQUEST = 'FETCH_LOGS_REQUEST';
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_FAILED = 'FETCH_LOGS_FAILED';
